import { Modal } from "antd";
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { totalTimeOrScore } from "../../helper/scoreCounter";
import { objectValidation } from "../../helper/validation";
import { AnswerContext } from "../../store/answerStore";
import { HelperContext } from "../../store/helperStore";
import { LaunchTestContext } from "../../store/launchTestStore";
import DefaultTestSum from "./defaultTestSum";
import TestSumCPT from "./testSumCPT";
import TestSumDnB1 from "./testSumDnB1";
import TestSumFNMix from "./testSumFNMix";
import "./testSummary.scss";
import TestSumSRCR from "./testSumSRCR";
import TestSumTextMatch from "./testSumTextMatch";
import { CalibrationTestSum } from "./calibrationTestSum";
import HideResultSum from "./hideResultSum";
import { getLocalStorage } from "../../helper/localStorage";

// import TestSumSR from "./testSumSR";
export default function TestSummary({ questions }) {
  const history = useHistory();
  const { launchTestC, dispatchLaunchTest } = LaunchTestContext();
  const { helperC, dispatchHelper } = HelperContext();
  const { launchTestData, loader, err } = launchTestC;
  const { answerC, dispatchAnswer } = AnswerContext();
  const isDemoTest = helperC.testType === "DEMO";
  const isCalibrationTest = helperC.testType === "CALIBRATION";

  const showResult = getLocalStorage("show_result");

  const [isThankModal, setIsThankModal] = useState(isDemoTest ? true : false);
  const [isSubmitModal, setIsSubmitModal] = useState(isDemoTest ? false : true);

  console.log(
    `%c answerC `,
    "font-size:2rem; background: #222; color: #bada55"
  );
  console.log(answerC);

  const launchTestQue =
    !isDemoTest &&
    !isCalibrationTest &&
    objectValidation(launchTestData) &&
    launchTestData.data[0];

  const handleGoBackToTestList = () => {
    setIsThankModal(false);
    history.goBack();
  };

  // for resetting totalTap for CPT
  useState(() => {
    launchTestQue.test_format === "tap_letter" &&
      dispatchHelper("RESET_TOTAL_TAP");
  }, []);

  return (
    <>
      {!isDemoTest && (
        <div
          className="test-block summary"
          style={{ display: isDemoTest ? "none" : "flex" }}
        >
          <div className="test-summary">
            {
              // for show_result
              //start
              showResult === "N" ? (
                <HideResultSum />
              ) : //end
              launchTestQue.test_format === "simple_reaction" ||
                launchTestQue.test_format === "choice_reaction" ? (
                <TestSumSRCR type={launchTestQue.test_format} />
              ) : launchTestQue.test_format === "tap_letter" ? (
                <TestSumCPT type={launchTestQue.test_format} />
              ) : launchTestQue.test_format === "tap_nback1" ? (
                <TestSumDnB1
                  isSubmit={isSubmitModal}
                  player_score={
                    totalTimeOrScore(answerC.answers, questions).player_score
                  }
                  answers={answerC.answers}
                  section_name={launchTestQue.section_name}
                ></TestSumDnB1>
              ) : launchTestQue.test_format === "text_match_scroll" ? (
                <TestSumTextMatch />
              ) : launchTestQue.test_format === "visual_facename_mix" ? (
                <TestSumFNMix
                  player_score={
                    totalTimeOrScore(answerC.answers, questions, "fnTest")
                      .player_score
                  }
                  answers={answerC.answers}
                  section_name={launchTestQue.section_name}
                ></TestSumFNMix>
              ) : helperC.testType === "CALIBRATION" ? (
                // <CalibrationTestSum />
                <CalibrationTestSum questions={questions} />
              ) : (
                <DefaultTestSum questions={questions} />
              )
            }

            <button
              onClick={() => {
                setIsThankModal(true);
              }}
              className="custom-btn addMargin"
            >
              Dashboard
            </button>
          </div>
        </div>
      )}
      <Modal
        visible={isSubmitModal}
        className="sml-modal"
        style={{ top: "36%" }}
        footer={
          <div className="sml-footer">
            <button
              className="custom-btn sml-btn"
              onClick={handleGoBackToTestList}
            >
              Go Back
            </button>
            <button
              className="custom-btn"
              onClick={() => setIsSubmitModal(false)}
            >
              Show Result
            </button>
          </div>
        }
      >
        <h2 style={{ textAlign: "center" }}>Submitted Successfully</h2>
      </Modal>

      <Modal
        className="sml-modal"
        visible={isThankModal}
        footer={
          <div className="sml-footer">
            <button className="custom-btn" onClick={handleGoBackToTestList}>
              Continue
            </button>
          </div>
        }
        style={{ top: "36%" }}
      >
        <h2 style={{ textAlign: "center" }}>
          Thank you for taking the{" "}
          {helperC.testType === "CALIBRATION"
            ? "calibration"
            : isDemoTest
            ? "demo"
            : ""}{" "}
          test
        </h2>
      </Modal>
    </>
  );
}
